import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectorRef, ViewChild, ElementRef} from '@angular/core';
import { QueovalDateService } from '../services/queovalDate.service';
import { QueovalDate } from '../models/global/class.global';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.css'],

})

export class DateComponent implements OnInit {
  constructor(
    // utilisé dans le HTML
    public qDateService: QueovalDateService,
    protected cd: ChangeDetectorRef,
    protected sanitizer: DomSanitizer
  ) { }

  @ViewChild('Input') Input!: ElementRef;

  

  //#region ngValue
  @Input('ngValue')
  set ngValue(value: QueovalDate) {
    this.cd.detectChanges();
    this._qNgModel = value;
    this._isValid = !this.qDateService.IsNull(value) && this.dateInrange(value) ? true : this._isValid;
  }
  @Output('ngValueChange') emitter: EventEmitter<QueovalDate> = new EventEmitter<QueovalDate>();
  //#endregion ngValue

  //#region Inputs
  public _name: string = '';
  @Input('name')
  set name(value: string) {
    this._name = !value ? '' : value;
  }

  public _id: string = '';
  @Input('id')
  set id(value: string) {
    this._id = !value ? '' : value;
  }


  @Input('value')
  set value(value: QueovalDate) {
    this._qNgModel = value;
  }

  public _max: string = '9999-12-31';
  @Input('max')
  set max(value: string) {
    this._max = !value ? '9999-12-31' : value;
  }

  public _min: string = '';
  @Input('min')
  set min(value: string) {
    this._min = !value ? '' : value;
  }

  public _step: string = '';
  @Input('step')
  set step(value: string) {
    this._step = !value ? '' : value;
  }

  public _style: any = null;
  @Input('style')
  set style(value: any) {
    this._style = !value ? null : this.sanitizer.bypassSecurityTrustStyle(value);
  }

  public _ngStyle: any = null;
  @Input('ngStyle')
  set ngStyle(value: any) {
    this._ngStyle = !value ? null : value;
  }

  public _class: any = null;
  @Input('class')
  set class(value: any) {
    this._class = !value ? null : value;
  }

  public _ngClass: any = null;
  @Input('ngClass')
  set ngClass(value: any) {
    this._ngClass = !value ? null : value;
  }



  public _autofocus: boolean = false;
  @Input('autofocus')
  set autofocus(value: boolean) {
    this._autofocus = !value ? false : value;
  }

  public _disabled: boolean = false;
  @Input('disabled')
  set disabled(value: boolean) {
    this._disabled = !value ? false : value;
  }

  public _list: string[] = [];
  @Input('list')
  set list(value: string[]) {
    this._list = !value ? [] : value;
  }

  public _readonly: boolean = false;
  @Input('readonly')
  set readonly(value: boolean) {
    this._readonly = !value ? false : value;
  }

  public classesRequired: string = '';
  public _required: boolean = false;
  @Input('required')
  set required(value: boolean | string) {
    this._required =  value === '' || value === true || value === 'true' || value === 'required' ? true :  false;
    this.classesRequired = this._required ? ' q-input-required q-main-focus ' : '';
  }

  public _tabindex: number | null = null;
  @Input('tabindex')
  set tabindex(value: number | null) {
    this._tabindex = !value ? null : value;
  }

  public _title: string = '';
  @Input('title')
  set title(value: any) {
    this._title = !value ? '' : value;
  }

  public _nullable: boolean = false;
  @Input('nullable')
  set nullable(value: boolean) {
    this._nullable = value;
  }
  //#endregion Inputs

  //#region Outputs
  @Output('change') change: EventEmitter<any> = new EventEmitter<any>();
  @Output('blur') blur: EventEmitter<any> = new EventEmitter<any>();
  @Output('click') click: EventEmitter<any> = new EventEmitter<any>();
  @Output('dblclick') dblclick: EventEmitter<any> = new EventEmitter<any>();
  @Output('focus') focus: EventEmitter<any> = new EventEmitter<any>();
  @Output('keydown') keydown: EventEmitter<any> = new EventEmitter<any>();
  @Output('keypress') keypress: EventEmitter<any> = new EventEmitter<any>();
  @Output('keyup') keyup: EventEmitter<any> = new EventEmitter<any>();
  @Output('isValid') isValid: EventEmitter<boolean> = new EventEmitter<boolean>();
  //#endregion Outputs

  public _qNgModel: QueovalDate = new QueovalDate();
  public _isLoaded: boolean = false;
  public _isValid: boolean = true;

  // #region CYCLE DE VIE
  ngOnInit(): void {
    this._isLoaded = true;
  }
  //#endregion

  //#region emit Output

  public OnChange(event: any): void {
    this.change.emit(event);
  }

  public OnClick(event: any): void {
    this.click.emit(event);
  }

  public OnDblclick(event: any): void {
    this.dblclick.emit(event);
  }

  public OnFocus(event: any): void {
    this.focus.emit(event);
  }

  public OnKeydown(event: any): void {
    this.keydown.emit(event);
  }

  public OnKeypress(event: any): void {
    this.keypress.emit(event);
  }

  public OnKeyup(event: any): void {
    this.keyup.emit(event);
  }

  // Recuperation de la valeur, test sa validité et emet la valeur
  public OnBlur(event: any): void {
    this._qNgModel = this.qDateService.FromStringInCentury(event.target.value);
    if (this.IsValid(this._qNgModel))
      this.emitter.emit(this._qNgModel);
    this.blur.emit(event);
  }

  //#endregion emit Output

  private IsValid(event: QueovalDate): boolean {
    this._isValid = !this.qDateService.IsNull(event) && this.dateInrange(event);
    this.isValid.emit(this._isValid);
    return this._isValid;
  }

  private dateInrange(value: QueovalDate): boolean {
    let ok: boolean = true;
    if (this._max) {
      ok = this.qDateService.Compare(value, '<=', this.qDateService.FromString(this._max))
    }
    if (this._min && ok) {
      ok = this.qDateService.Compare(value, '>=', this.qDateService.FromString(this._min))
    }
    return ok;
  }

}
